import React, { useState, useRef, useEffect } from 'react';
import { createMonthDepreciation, lockMonthDepreciation, getCreateMonthData } from '../../../services/asset.service';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import './AssetDepreciation.css';
import * as CryptoJS from "crypto-js";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';

export default function AssetDepreciation() {
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState('');
  const [fnSession, setFnSession] = useState('');
  const [ErrSession, setErrSession] = useState('');
  const [items, setItems] = useState([]);
  const [monthsData, setMonthsData] = useState({
    april: null,
    may: null,
    june: null,
    july: null,
    august: null,
    september: null,
    october: null,
    november: null,
    december: null,
    january: null,
    february: null,
    march: null
  });

  useEffect(() => {
    setErrSession('');
    setItems([]);
  }, []);

  useEffect(() => {
    if (items?.length) {
      setMonthsData({
        april: items.find(obj => obj.month == 4),
        may: items.find(obj => obj.month == 5),
        june: items.find(obj => obj.month == 6),
        july: items.find(obj => obj.month == 7),
        august: items.find(obj => obj.month == 8),
        september: items.find(obj => obj.month == 9),
        october: items.find(obj => obj.month == 10),
        november: items.find(obj => obj.month == 11),
        december: items.find(obj => obj.month == 12),
        january: items.find(obj => obj.month == 1),
        february: items.find(obj => obj.month == 2),
        march: items.find(obj => obj.month == 3)
      });
    } else {
      setMonthsData({
        april: null,
        may: null,
        june: null,
        july: null,
        august: null,
        september: null,
        october: null,
        november: null,
        december: null,
        january: null,
        february: null,
        march: null
      });
    }
  }, [items]);

  const handleFinancialYear = (e) => {
    let value = e.target.value;

    if (value !== '') {
      setFnSession(value);
      setErrSession('');
      var obj = {
        'fy_year': parseInt(value) + '-' + (parseInt(value) + 1),
        'token': sessionStorage.getItem('LoggedInToken'),
      };
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData = { 'token': EncryptData }
      
      getCreateMonthData(oData).then(res => {
        if (res?.data?.data?.res?.length) {
          setItems(res.data.data.res);
        }
      });
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  const createMonthTable = (monthValue) => {
    if (fnSession !== '' && monthValue !== '') {
      setErrSession('');
      try {
        var obj = {
          'fy_year': parseInt(fnSession) + '-' + ((parseInt(fnSession) + 1)),
          'year': (monthValue == "1" || monthValue == "2" || monthValue == "3") ? parseInt(fnSession) + 1 : parseInt(fnSession),
          'month': monthValue,
          'creation_flag': 'Y',
          'lock_status': 'N',
          'company_id': sessionStorage.getItem('LoggedInCompanyId'),
          'division_id': sessionStorage.getItem('LoggedInDivisionId'),
          'created_by': sessionStorage.getItem('LoggedInUserId'),
          'token': sessionStorage.getItem('LoggedInToken'),
        };
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
          'param_data': obj,
          'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData }
        
        createMonthDepreciation(oData1).then(function (res) {
          if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
            setErrMsg(res.data.message);
            setSuccess(false);
          } else {
            setSuccess(res.data.message);
            handleFinancialYear({ target: { value: fnSession } });
          }
        });
      } catch (err) {
        setSuccess(false);
        setErrMsg(err.data.message);
      }
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  const lockMontTable = (monthValue) => {
    if (fnSession !== '' && monthValue !== '') {
      setErrSession('');
      confirmAlert({
        title: "Lock Month Confirmation",
        message: "Are you sure you want to lock this month?",
        buttons: [
          {
            label: "Yes, Lock",
            onClick: () => lockMontSubmitTable(monthValue),
            className: 'confirm-yes-btn'
          },
          {
            label: "Cancel",
            className: 'confirm-no-btn'
          }
        ],
        overlayClassName: "custom-confirm-overlay"
      });
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  function lockMontSubmitTable(value) {
    try {
      var obj = {
        'fy_year': parseInt(fnSession) + '-' + ((parseInt(fnSession) + 1)),
        'year': (value == "1" || value == "2" || value == "3") ? parseInt(fnSession) + 1 : parseInt(fnSession),
        'month': value,
        'creation_flag': 'Y',
        'lock_status': 'Y',
        'company_id': sessionStorage.getItem('LoggedInCompanyId'),
        'division_id': sessionStorage.getItem('LoggedInDivisionId'),
        'created_by': sessionStorage.getItem('LoggedInUserId'),
        'token': sessionStorage.getItem('LoggedInToken'),
      };
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData2 = { 'token': EncryptData }
      
      lockMonthDepreciation(oData2).then(function (res) {
        setSuccess(res.data.message);
        handleFinancialYear({ target: { value: fnSession } });
      });
    } catch (err) {
      setSuccess(false);
      setErrMsg(err.data.message);
    }
  }

  const unlockMontTable = (monthValue) => {
    if (fnSession !== '' && monthValue !== '') {
      setErrSession('');
      confirmAlert({
        title: "Unlock Month Confirmation",
        message: "Are you sure you want to unlock this month?",
        buttons: [
          {
            label: "Yes, Unlock",
            onClick: () => unlockMontSubmitTable(monthValue),
            className: 'confirm-yes-btn'
          },
          {
            label: "Cancel",
            className: 'confirm-no-btn'
          }
        ],
        overlayClassName: "custom-confirm-overlay"
      });
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  function unlockMontSubmitTable(value) {
    try {
      var obj = {
        'fy_year': parseInt(fnSession) + '-' + ((parseInt(fnSession) + 1)),
        'year': (value == "1" || value == "2" || value == "3") ? parseInt(fnSession) + 1 : parseInt(fnSession),
        'month': value,
        'creation_flag': 'Y',
        'lock_status': 'N',
        'company_id': sessionStorage.getItem('LoggedInCompanyId'),
        'division_id': sessionStorage.getItem('LoggedInDivisionId'),
        'created_by': sessionStorage.getItem('LoggedInUserId'),
        'token': sessionStorage.getItem('LoggedInToken'),
      };
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData3 = { 'token': EncryptData }
      
      lockMonthDepreciation(oData3).then(function (res) {
        setSuccess(res.data.message);
        handleFinancialYear({ target: { value: fnSession } });
      });
    } catch (err) {
      setSuccess(false);
      setErrMsg(err.data.message);
    }
  }

  const clickMonthTable = (monthValue) => {
    if (fnSession !== '' && monthValue !== '') {
      var session = fnSession;
      if (monthValue == "1" || monthValue == "2" || monthValue == "3") {
        session = (parseInt(fnSession) + 1);
      }
      setErrSession('');
      let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
        'finance_month': monthValue, 'finance_year': session, 'back_url': 'asset-depreciation'
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      window.location.href = "/generate-depreciation?finance=" + EncryptID;
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  const MonthCard = ({ month, monthName, monthValue, data }) => {
    const isLocked = data?.lock_status === 'Y';
    const isCreated = !!data;

    return (
      <div className="col-lg-12 col-md-4 col-sm-6 mb-4">
        <div className={`month-card ${isLocked ? 'locked' : isCreated ? 'created' : 'pending'}`}>
          <div className="month-card-header">
            <CalendarMonthIcon className="month-icon" />
            <h3 className="month-name">{monthName}</h3>
            {isLocked && <LockIcon className="lock-badge" />}
            {isCreated && !isLocked && <CheckCircleIcon className="created-badge" />}
          </div>

          <div className="month-card-body">
            {isLocked ? (
              <>
                <div className="month-status locked-status">
                  <LockIcon fontSize="small" />
                  <span>Locked</span>
                </div>
                <button
                  onClick={() => unlockMontTable(monthValue)}
                  className="btn-unlock"
                >
                  <LockOpenIcon fontSize="small" />
                  Unlock Month
                </button>
              </>
            ) : isCreated ? (
              <>
                <div className="month-status created-status">
                  <CheckCircleIcon fontSize="small" />
                  <span>Created</span>
                </div>
                <div className="month-actions">
                  <button
                    onClick={() => clickMonthTable(month)}
                    className="btn-view"
                  >
                    <i className="bi bi-eye"></i>
                    View Details
                  </button>
                  <button
                    onClick={() => lockMontTable(monthValue)}
                    className="btn-lock"
                  >
                    <LockIcon fontSize="small" />
                    Lock
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="month-status pending-status">
                  <InfoIcon fontSize="small" />
                  <span>Not Created</span>
                </div>
                <button
                  onClick={() => createMonthTable(monthValue)}
                  className="btn-create"
                >
                  <AddCircleIcon fontSize="small" />
                  Create Month
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='depreciation-container'>
      {/* Header Section */}
      <div className='page-header-dep'>
        <div className='header-content-dep'>
          <div className='header-left-dep'>
            <div className='header-icon-dep'>
              <CalendarMonthIcon style={{ fontSize: '2rem' }} />
            </div>
            <div>
              <h3 className='page-title-dep'>Generate Depreciation</h3>
              <p className='page-subtitle-dep'>Manage monthly depreciation calculations</p>
            </div>
          </div>
        </div>

        {/* Alert Messages */}
        {success && (
          <div className="alert-success-dep">
            <CheckCircleIcon />
            <span>{success}</span>
          </div>
        )}
        {errMsg && (
          <div className="alert-danger-dep">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>{errMsg}</span>
          </div>
        )}
      </div>

      {/* Financial Year Selection */}
      <div className='fy-selection-card'>
        <div className='fy-selection-header'>
          <h5>
            <i className="bi bi-calendar3"></i> Select Financial Year
          </h5>
        </div>
        <div className='fy-selection-body'>
          <div className='fy-input-group'>
            <select
              onChange={handleFinancialYear}
              value={fnSession}
              className="fy-select"
            >
              <option value="">Select Financial Year</option>
              {[...Array(20)].map((_, i) => {
                const year = 2025 - i;
                return (
                  <option key={year} value={year}>
                    FY-{year}-{(year + 1).toString().substr(-2)}
                  </option>
                );
              })}
            </select>
            <button
              onClick={() => handleFinancialYear({ target: { value: fnSession } })}
              className="btn-fetch"
              disabled={!fnSession}
            >
              <i className="bi bi-search"></i>
              Fetch Data
            </button>
          </div>
          {ErrSession && <span className="error-message">{ErrSession}</span>}
        </div>
      </div>

      {/* Info Card */}
      {fnSession && (
        <div className='info-card'>
          <InfoIcon style={{ color: '#0084ff' }} />
          <div>
            <strong>Financial Year {fnSession}-{parseInt(fnSession) + 1}</strong>
            <p>Select a month below to create, view, or manage depreciation records</p>
          </div>
        </div>
      )}

      {/* Months Grid */}
      <div className='months-grid'>
        <MonthCard month="4" monthName="April" monthValue="04" data={monthsData.april} />
        <MonthCard month="5" monthName="May" monthValue="05" data={monthsData.may} />
        <MonthCard month="6" monthName="June" monthValue="06" data={monthsData.june} />
        <MonthCard month="7" monthName="July" monthValue="07" data={monthsData.july} />
        <MonthCard month="8" monthName="August" monthValue="08" data={monthsData.august} />
        <MonthCard month="9" monthName="September" monthValue="09" data={monthsData.september} />
        <MonthCard month="10" monthName="October" monthValue="10" data={monthsData.october} />
        <MonthCard month="11" monthName="November" monthValue="11" data={monthsData.november} />
        <MonthCard month="12" monthName="December" monthValue="12" data={monthsData.december} />
        <MonthCard month="1" monthName="January" monthValue="01" data={monthsData.january} />
        <MonthCard month="2" monthName="February" monthValue="02" data={monthsData.february} />
        <MonthCard month="3" monthName="March" monthValue="03" data={monthsData.march} />
      </div>
    </div>
  )
}